export function isSubmitKey({ code }: { code: string }) {
  return ['Enter', 'NumpadEnter'].includes(code);
}

export const MAXIMUM_QUERY_LENGTH = 1024;
export const QUERY_TOO_LONG_MESSAGE = `Search query must be ${MAXIMUM_QUERY_LENGTH.toLocaleString()} characters or fewer`;
